export enum InputOutputEmitter{
  EXPAND = 'EXPAND',
  COLLAPSED = 'COLLAPSED',
  REFRESH = 'REFRESH'
}
